import { render, staticRenderFns } from "./uploadvideo.vue?vue&type=template&id=0244945a&scoped=true&"
import script from "./uploadvideo.vue?vue&type=script&lang=js&"
export * from "./uploadvideo.vue?vue&type=script&lang=js&"
import style0 from "./uploadvideo.vue?vue&type=style&index=0&id=0244945a&prod&lang=css&"
import style1 from "./uploadvideo.vue?vue&type=style&index=1&id=0244945a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0244945a",
  null
  
)

export default component.exports